module.exports = __webpack_public_path__ + "media/question2_en.a326764a.mp3";